import { Plan, PlanPrice } from "../types";

export const PLAN_PRICING: Record<Plan, PlanPrice> = {
    [Plan.Public]: { monthly: "Free", annual: "Free" },
    [Plan.UbpBasic]: { monthly: 65, annual: 49 },
    [Plan.UbpCore]: { monthly: 99, annual: 79 },
    [Plan.UbpGrowth]: { monthly: 399, annual: 299 },
    [Plan.UbpPremiumTrial]: { monthly: 399, annual: 299 },
    [Plan.EnterpriseGrowth]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.Enterprise]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.LegacySandbox]: { monthly: "Free", annual: "Free" },
    [Plan.LegacyStarter]: { monthly: 249, annual: 200 },
    [Plan.Research]: { monthly: "Free", annual: "Free" },
    [Plan.UninitalizedWorkspace]: { monthly: "N/A", annual: "N/A" }
} as any;
